import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router, NavigationExtras } from "@angular/router";
import { PageService } from "../../core/services/page.service";
import { EventService } from "../../core/services/event.service";
import { NgForm } from '@angular/forms';
import { FormsComponent } from '../../core/interfaces';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import {NationalTeamsService} from '../../core/services/national-teams.service';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'app-edit-page',
    templateUrl: './edit-page.component.html',
    styleUrls: ['./edit-page.component.scss']
})
export class EditPageComponent implements FormsComponent, OnInit {
    @ViewChild('tabSet') tabSet: NgbNav;

    forms: NgForm[] = [];

    public page: any = {};
    public isTeam: string;
    public activeTab: string;
    public pageId: number;
    public donationAmounts: any = [];
    public isNationalTeamPage: boolean;
    public cssClass: string;

    constructor(public eventService: EventService,
                private activatedRoute: ActivatedRoute,
                private pageService: PageService,
                private router: Router,
                private nationalTeamsService: NationalTeamsService) {
        this.eventService.onEventChange.subscribe(event => {
            // FIXME: Levon: We need to find solution to unsubscribe onEventChange
            if (this.router.url.includes('/edit')) {
                if (this.isTeam === '1') {
                    if (this.eventService.selectedEvent.gql.Participant[0].team) {
                        let navigationExtras: NavigationExtras = {
                            queryParams: {'isTeam': '1'}
                        };
                        this.pageService.getTeamPage(this.eventService.selectedEvent.participantId, this.eventService.selectedEvent.gql.Participant[0].team.teamId, true).subscribe(res => {
                            if (this.pageId !== event.value) {
                                this.router.navigate(['/edit', res.pageID], navigationExtras);
                            }
                        });
                    } else {
                        this.router.navigate(['/home']);
                    }
                } else {
                    this.pageService.getUserPage(this.eventService.selectedEvent.participantId, true).subscribe(res => {
                        if (this.pageId !== event.value) {
                            this.router.navigate(['/edit', res.pageID]);
                        }
                    });
                }
            }
        });

        this.nationalTeamsService.onNationalTeamChange.subscribe(nationalTeam => {
            if (this.router.url.includes('/edit')) {
                if (this.nationalTeamsService.selectedNationalTeam) {
                    let navigationExtras: NavigationExtras = {
                        queryParams: {'isTeam': '1', 'isNationalTeamPage': '1'}
                    };
                    this.pageService.getNationalTeamPage(this.nationalTeamsService.selectedNationalTeam.nationalTeamPageId, true).subscribe(res => {
                        if (this.pageId !== nationalTeam.nationalTeamPageId) {
                            this.router.navigate(['/edit', res.pageID], navigationExtras);
                        }
                    });
                } else {
                    this.router.navigate(['/home']);
                }
            }
        });
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.pageId = parseInt(params['pageID']);
            this.isNationalTeamPage = this.activatedRoute.snapshot.queryParams['isNationalTeamPage'];
            let page = null;
            if (!!this.isNationalTeamPage) {
                page = this.pageService.getPageForNationalTeam(this.pageId);
            } else {
                page = this.pageService.getPageById(this.pageId);
            }

            if (page) {
                this.page = JSON.parse(JSON.stringify(page));
            } else {
                //TODO: is this right?
                this.page = null;
            }
        });

        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.isTeam = params['isTeam'];
            this.activeTab = params['activeTab'];
            this.isNationalTeamPage = params['isNationalTeamPage'];
        });

        this.donationAmounts = this.activatedRoute.snapshot.data['donationAmounts'];
        if (this.isNationalTeamPage) {
            this.cssClass = this.nationalTeamsService.selectedNationalTeam.cssClass;
        } else {
            this.cssClass = this.eventService.selectedEvent.cssClass;
        }

    }

    showOptionsTab(eventType) {
        if (!this.isTeam && !this.isNationalTeamPage) {
            return true;
        } else if (this.isTeam) {
            if (eventType === 'program-mwoy' || eventType === 'program-voy' || eventType === 'program-soy' || eventType === 'program-svoy') {
                return false;
            } else {
                return true;
            }
        }
    }

    showNewsFeedTab(eventType) {
        //The News feed is only applicable to MWOY.  While SOY is derived from MWOY, all SOY events are currently created
        //in EventBuilder and the template does not expose the News Feed in the UI.  Once SOY events become "regular" events
        //or when the template in EventBuilder is updated, we can restore the SOY check
        if (eventType === 'program-mwoy' || eventType === 'program-voy') { // || eventType === 'program-soy' || eventType === 'program-svoy') {
            return true;
        } else {
            return false;
        }
    }

    addForm(form: NgForm) {
        this.forms.push(form);
    }

    getParamsForTab(activeTabName) {
        let params = {activeTab: activeTabName};
        if (!!this.isTeam) {
            params['isTeam'] = 1;
        }
        if (!!this.isNationalTeamPage) {
            params['isNationalTeamPage'] = 1;
        }
        return params;
    }

    isPastItemPage() {
        if (!!this.isNationalTeamPage) {
            const selectedNationalTeam = this.nationalTeamsService.selectedNationalTeam;
            return !!selectedNationalTeam && !!selectedNationalTeam.isPastNationalTeam;
        } else {
            const selectedEvent = this.eventService.selectedEvent;
            return !!selectedEvent && !!selectedEvent.isPastEvent;
        }
    }
}
